import {Injectable} from "@angular/core";
import {SsrCookieService} from "ngx-cookie-service-ssr";
import {SecureStorageLocal} from "@app/core/shared/domain/storage/secure-storage.local";

@Injectable()
export class CookiesSecureLocalStorage implements SecureStorageLocal {
    private static readonly GLOBAL_PATH: string = '/';

    constructor(private cookieService: SsrCookieService) {}

    public async getItem(key: string): Promise<string | null> {
      return this.cookieService.get(key) ?? null;
    }

    public async setItem(key: string, value: string): Promise<void> {
        this.cookieService.set(key, value, { path: CookiesSecureLocalStorage.GLOBAL_PATH });
    }

    public async removeItem(key: string): Promise<void> {
        this.cookieService.delete(key, CookiesSecureLocalStorage.GLOBAL_PATH);
    }

    public async clear(): Promise<void> {
        this.cookieService.deleteAll(CookiesSecureLocalStorage.GLOBAL_PATH);
    }
}
